
import React from 'react';
import { Info } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { BookOpen, ArrowRight } from 'lucide-react';

const UlosottoIntroSection: React.FC = () => {
  return (
    <>
      <h2>Mikä on ulosotto?</h2>
      <p>
        Ulosotto on viranomaistoimintaa, jossa velalliselta peritään pakolla saatavia, joita hän ei ole vapaaehtoisesti maksanut. 
        Kyseessä voi olla maksamattomia laskuja, lainoja, veroja tai muita maksuja, joista on annettu tuomio tai muu ulosottoperuste.
      </p>
      
      <p>
        Ulosoton tarkoituksena on toteuttaa maksuvelvoite lain määräämällä tavalla. Ulosottoviranomaiset ovat valtion virkamiehiä, 
        ja he toimivat puolueettomasti sekä velkojan että velallisen edut huomioiden.
      </p>

      <div className="bg-blue-50 p-6 rounded-lg mb-8">
        <h2 className="text-blue-800 text-xl font-semibold mb-3">Tämä artikkeli sisältää</h2>
        <ul className="list-disc pl-6 space-y-1 text-blue-700">
          <li>Mikä on ulosotto ja miksi se tapahtuu</li>
          <li>Ulosottoprosessin vaiheet yksinkertaisesti selitettynä</li>
          <li>Velallisen oikeudet ja suojaosuudet</li>
          <li>Ulosoton välttäminen ja vaihtoehdot</li>
          <li>Käytännön toimintaohjeet ulosottotilanteessa</li>
        </ul>
      </div>

      <h2>Milloin velka siirtyy ulosottoon?</h2>
      <div className="flex flex-col md:flex-row gap-8 mb-6">
        <div className="flex-1">
          <p>
            Velka voi siirtyä ulosottoon, kun:
          </p>
          <ul>
            <li>Velkaa ei ole maksettu eräpäivään mennessä</li>
            <li>Velka on siirtynyt perintätoimistolle</li>
            <li>Perintä ei ole tuottanut tulosta</li>
            <li>Velasta on haettu tuomioistuimen päätös</li>
          </ul>
          <p>
            Yleensä prosessi etenee niin, että ensin laskusta tulee maksumuistutus, sitten perintäkirje, 
            ja jos maksua ei edelleenkään suoriteta, asia voidaan viedä käräjäoikeuteen, joka antaa 
            velkomustuomion. Tämän jälkeen velka voidaan siirtää ulosottoon.
          </p>
        </div>
        <div className="flex-1">
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
            <h3 className="text-lg font-semibold mb-3 flex items-center"><Info size={20} className="mr-2 text-blue-600" /> Ulosottoprosessin aikajana</h3>
            <ol className="list-decimal pl-6 space-y-3">
              <li>Lasku erääntyy</li>
              <li>Maksumuistutus (yleensä 14 pv)</li>
              <li>Perintäkirje(et) (30-60 pv)</li>
              <li>Haaste käräjäoikeuteen (n. 1-3 kk)</li>
              <li>Tuomioistuimen päätös</li>
              <li>Ulosottoviranomaisen vireillepanoilmoitus</li>
              <li>Ulosmittaus alkaa</li>
            </ol>
          </div>
        </div>
      </div>

      <Link to="/lainat/ulosottolaskuri" className="inline-block my-6">
        <Button variant="outline" className="flex items-center">
          <BookOpen className="mr-2 h-4 w-4" />
          Laske ulosmittauksen määrä laskurillamme
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </Link>
    </>
  );
};

export default UlosottoIntroSection;
